<template>
    <div class="pa-5 compact-form" v-if="activeClient">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Client name" | t }} <span class="required">*</span></v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.name"
                    class="text-field-item mb-1"
                    dense
                    :rules="[v => !!v || t('Required field')]"
                    outlined
                    @input="updateField($event, 'name')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Chain name" | t }} <span class="required">*</span></v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.chain_name"
                    class="text-field-item mb-1"
                    dense
                    :rules="[v => !!v || t('Required field')]"
                    outlined
                    @input="updateField($event, 'chain_name')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Shop name" | t }} <span class="required">*</span></v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.shop_name"
                    class="text-field-item mb-1"
                    dense
                    :rules="[v => !!v || t('Required field')]"
                    outlined
                    @input="updateField($event, 'shop_name')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Shop type" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.shop_type"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField($event, 'shop_type')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Business type" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.business_type"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField($event, 'business_type')"
                />
            </v-col>
        </v-row>
        <v-divider class="my-3" />
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Address" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.shop_address"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField($event, 'shop_address')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "City" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.shop_place"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField($event, 'shop_place')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Parish" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.shop_parish"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField($event, 'shop_parish')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "County" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.shop_county"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField($event, 'shop_county')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Index" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.shop_index"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField($event, 'shop_index')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Country" | t }} <span class="required">*</span></v-col>
            <v-col cols="6">
                <v-autocomplete
                    v-model="country"
                    :items="countries"
                    :loading="isLoading"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    hide-no-data
                    hide-selected
                    :item-text="
                        item =>
                            (item.name_et ? item.name_et : null) +
                            (item.name_en ? item.name_en : null) +
                            ' (' +
                            item.code +
                            ')'
                    "
                    item-value="code"
                    outlined
                    :placeholder="t('Start typing to Search')"
                    return-object
                >
                    <template slot="selection" slot-scope="{ item, selected }">
                        {{ item.name_et ? item.name_et : item.name_en }} ({{ item.code }})
                    </template>
                    <template slot="item" slot-scope="{ item, tile }">
                        <country-flag :country="item.code" size="small" class="mr-1" />
                        {{ item.name_et ? item.name_et : item.name_en }} ({{ item.code }})
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col :cols="1">
                <country-flag v-if="country && country.code" :country="country.code" class="mt-0 ml-1" size="normal" />
            </v-col>
        </v-row>
        <v-divider class="my-3" />
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Latitude" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.latitude"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    type="number"
                    @input="updateField($event, 'latitude')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Longitude" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.longitude"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    type="number"
                    @input="updateField($event, 'longitude')"
                />
            </v-col>
        </v-row>
        <v-divider class="my-3" />
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Comment" | t }}</v-col>
            <v-col cols="6">
                <v-textarea
                    :value="activeClient.comment"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    rows="3"
                    @input="updateField($event, 'comment')"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Store from "@/store";
import { mapState, mapActions } from "vuex";
import CountryFlag from "vue-country-flag";

export default {
    name: "client-info-edit-tab",
    components: {
        CountryFlag
    },
    data() {
        return {
            isLoading: false,
            country: null
        };
    },

    async mounted() {
        this.isLoading = true;
        if (this.countries.length === 0) {
            await Store.dispatch("fetchCountries");
        }
        setTimeout(() => {
            if (this.activeClient.country_code) {
                this.country = this.countries.find(x => x.code === this.activeClient.country_code);
            }
            this.isLoading = false;
        }, 200);
    },
    watch: {
        country: function(value) {
            value && value.code ? this.updateField(value.code, "country") : this.updateField(null, "country");
        }
    },
    methods: {
        ...mapActions(["getFrequentlyUsedQueries"]),
        updateField(value, field) {
            Store.commit("ClientStore/updateActiveClientProperty", { prop: field, value: value });
        }
    },
    computed: {
        ...mapState(["countries"]),
        ...mapState("ClientStore", ["activeClient"])
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
.required {
    color: #f41823;
}
</style>
